import React from 'react';

/**
 * Attaches a `cancel` event listener to a file input element.
 * The `cancel` event fires when the user closes the native OS file picker
 * without selecting any files. Use this to clear spinner/loading state.
 */
export function useFileInputCancelListener(
  inputRef: React.RefObject<HTMLInputElement | null>,
  onCancel: () => void
) {
  React.useEffect(() => {
    const input = inputRef.current;
    if (!input) return;
    input.addEventListener('cancel', onCancel);
    return () => input.removeEventListener('cancel', onCancel);
  }, [inputRef, onCancel]);
}
